import "./BusinessCorporateServices.module.css";
import BusinessFormationOwnershipPlanning from "./sections/BusinessFormationOwnershipPlanning";
import BusinessPurchasesSalesOwnershipTransitions from "./sections/BusinessPurchasesSalesOwnershipTransitions";
import ContractsOwnershipAndDisputePrevention from "./sections/ContractsOwnershipAndDisputePrevention";
import Footer from "@/reusable_sections/Footer";
import Mainheader from "./sections/Mainheader";
export default function BusinessCorporateServicesPage() {
  return <div>
      <Mainheader />
      <BusinessFormationOwnershipPlanning />
      <BusinessPurchasesSalesOwnershipTransitions />
      <ContractsOwnershipAndDisputePrevention />
      <Footer />
    </div>;
}